export const dateFormat = {
  timeSeconds: 'HH:mm:ss',
  time: 'HH:mm',
  dateISO: 'yyyy-MM-dd',
  datePublic: 'dd.\u00A0MM.\u00A0yyyy',
  shortPublicDate: 'd.\u00A0M.\u00A0yyyy',
  dateInYear: 'd.\u00A0M.',
  dateTime: 'd.\u00A0M.\u00A0yyyy HH:mm'
} as const
